
import { OverlayContainer } from '@angular/cdk/overlay';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ModalHelperService {
  constructor(
    private overlayContainer: OverlayContainer,
  ) {
  }

  public appendModalOverrideClass(element: Element) {
    // this is a hack, see notes in emds-modal.less
    element.parentElement?.parentElement?.parentElement?.classList.add('modal-top');

    // this call is paired with ApModalHelper.makeCompatibleWithBootstrapModalOnDestroy(),
    // and ideally this code would live there instead if it didn't require extra refactoring
    this.overlayContainer.getContainerElement().classList.add('modal-container-top');
  }
}
